import { useTranslation } from 'react-i18next'
import { ObjectiveWorkflowState } from '@/api/models/aggregate'

export const useGetCourseStateTranslator = () => {
  const { t } = useTranslation()

  return (state: ObjectiveWorkflowState | undefined) => {
    if (!state) {
      return t('courseStates.notStarted')
    }

    switch (state) {
      case ObjectiveWorkflowState.inProgress:
        return t('courseStates.inProgress')
      case ObjectiveWorkflowState.submitted:
        return t('courseStates.submitted')
      case ObjectiveWorkflowState.inGrading:
        return t('courseStates.inGrading')
      case ObjectiveWorkflowState.graded:
        return t('courseStates.graded')
      case ObjectiveWorkflowState.gradingApproved:
        return t('courseStates.gradingApproved')
      case ObjectiveWorkflowState.finished:
        return t('courseStates.finished')
    }
  }
}
